import Button from '@atoms/Button/Button';
import type { ILink } from '@models/ILink';
import type { IMeta } from '@models/IMeta';

interface Props {
  readonly title?: string;
  readonly link?: ILink;
  readonly meta?: IMeta;
}

const CtaBanner = ({ title, link, meta }: Props) =>
  title || (link?.name && link?.url) ? (
    <section
      className="component-padding bg-white text-black-100 dark:bg-black-100 dark:text-white"
      data-testid="CTA-Banner"
    >
      <div className="container lg:grid lg:grid-cols-12">
        <div className="space-y-7.5 lg:col-span-7 lg:space-y-10">
          {title && (
            <p
              className="h3"
              data-testid="CTA-Banner-Title"
              data-epi-property-name={meta?.editHints?.title}
            >
              {title}
            </p>
          )}

          {link?.name && link.url && (
            <Button
              link={link}
              editHint={meta?.editHints?.link as string | undefined}
              dataTestId="CTA-Banner-Link"
            >
              {link.name}
            </Button>
          )}
        </div>
      </div>
    </section>
  ) : null;

export default CtaBanner;
